import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbNavModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CompanyPageComponent } from '../../pages/company-page/company-page.component';

// ANCHOR NGPRIME
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DragDropModule } from 'primeng/dragdrop';
import { ToLocalDatePipe } from '../../pipes/to-local-date.pipe';


@NgModule({
  declarations: [
    CompanyPageComponent,
    ToLocalDatePipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    TableModule,
    InputSwitchModule,
    ButtonModule,
    DropdownModule,
    NgSelectModule,
    DragDropModule,
    NgbNavModule,
    NgbDatepickerModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    CompanyPageComponent,
    TableModule,
    InputSwitchModule,
    ButtonModule,
    DropdownModule,
    NgSelectModule,
    DragDropModule,
    NgbNavModule,
    NgbDatepickerModule,
    ToLocalDatePipe
  ]
})
export class SharedModule { }
